import { render, staticRenderFns } from "./ReadyForOnboarding.vue?vue&type=template&id=ba2f1f98"
import script from "./ReadyForOnboarding.vue?vue&type=script&lang=js"
export * from "./ReadyForOnboarding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports